import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import { PageContainer, DocumentsTable } from '../../components';
import { useGetCase } from '../../hooks/useGetCase';
import { useListDocumentAvailability } from '../../hooks/useListDocumentAvailability';
import { Case } from '../../types/Case';

export function Documents() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const rawId = searchParams.get('id');
  const caseId = rawId ? `Case_${rawId}` : null;
  //get data
  const { data: caseData, refetch: refetchCase } = useGetCase({
    id: caseId || undefined,
    useCache: true,
  });
  const {
    fetchDocumentAvailability,
    data: documentData,
    loading,
    error,
  } = useListDocumentAvailability();

  useEffect(() => {
    if (caseId) {
      refetchCase({ input: caseId });
      fetchDocumentAvailability(caseId);
    }
  }, [caseId]);

  //get data from cache
  const { details, role } = caseData?.getCase || ({} as Case);
  const { items } = documentData?.listDocuments || {};

  return (
    <PageContainer>
      <Box sx={{ p: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Typography variant="h1" sx={{ maxWidth: '800px', marginBottom: 0 }}>
            {`Manage Documents - ${details?.name}`}
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ marginBottom: '0.75rem' }}>
          {role === 'Owner' || role === 'Editor' ? 'View documents' : 'View documents'}
        </Typography>
        {caseId && (
          <DocumentsTable
            loading={loading}
            error={error?.message}
            data={items || []}
            caseId={caseId}
          />
        )}
      </Box>
    </PageContainer>
  );
}

export default Documents;
